<template>
  <div class="px-8">
    <VCard>
      <div class="setting-security white">
        <VDialog
          v-if="isPasswordDialogShow"
          :value="isPasswordDialogShow"
          width="425"
          persistent
        >
          <component
            :is="currentDialogComponent"
            :caption="$t('settings.changePassword')"
            :body="$t('settings.passwordChangeSuccessMsg')"
            @onChangePasswordSuccess="onChangePasswordSuccess"
            @closeDialog="isPasswordDialogShow = false"
          />
        </VDialog>
        <div class="p-4 mb-3">
          <span
            class="heading-6 textPrimary--text font-weight-bold"
          >
            {{ $t('settings.security') }}
          </span>
        </div>
        <div class="px-4 pb-6">
          <div class="mb-3">
            <span class="body-2 textSecondary--text text-uppercase">{{ $t('settings.password') }}</span>
          </div>
          <div class="d-flex justify-space-between align-center">
            <span
              class="body-1 textPrimary--text"
            >
              {{ $t('settings.setYourPassword') }}
            </span>
            <VBtn
              text
              color="brandingPrimary"
              class="body-2 ml-4"
              data-test="change-password-button"
              @click="toChangePassword"
            >
              {{ $t('settings.change') }}
            </VBtn>
          </div>
          <template v-if="false">
            <VDivider />
            <div class="mb-3">
              <span class="body-2 textSecondary--text text-uppercase">{{ $t('settings.cookieConsent') }}</span>
            </div>
            <div class="d-flex justify-space-between align-center">
            <span
                class="body-1 textPrimary--text"
            >
              {{ $t('settings.acceptCookieForm') }}
            </span>
              <VBtn
                  text
                  color="brandingPrimary"
                  class="body-2 ml-4"
                  @click="$emit('closeForm')"
              >
                {{ $t('settings.update') }}
              </VBtn>
            </div>
          </template>
        </div>
      </div>
    </VCard>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SSettingsSecurity',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import ChangePasswordDialog from './ChangePasswordDialog.vue';
import SuccessDialog from '../SuccessDialog.vue';

const isPasswordDialogShow = ref(false);
const currentDialog = ref('');

const dialogComponents = {
  ChangePasswordDialog,
  SuccessDialog,
};
const currentDialogComponent = computed(() => dialogComponents[currentDialog.value]);

function toChangePassword() {
  currentDialog.value = 'ChangePasswordDialog';
  isPasswordDialogShow.value = true;
}

function onChangePasswordSuccess() {
  currentDialog.value = 'SuccessDialog';
}
</script>
